var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-title flex-center"},[_c('div',{staticClass:"base-tittle-icon"},[_vm._t("icon")],2),_c('div',{staticClass:"base-title-text flex-item",style:(_vm.getSize)},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"base-title-action"},[_vm._t("action")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }